<template>

    <div>
      <form-container :title="stageTitle">
            <h3>Your policy</h3>
            <label for="policyNumber">Number</label>
            <input  class="reviewInputs" type="text" id="policyNumber" ref="policyNumber" name="policyNumber" placeholder="" :value="policyNumber" disabled>
        </form-container>

        <form-container class="mt-3">
            <div>
                <h3>Your contact details</h3>
            </div>
            <label for="email">Email</label>
            <input class="reviewInputs" type="text" id="email" ref="email" name="email" placeholder="" :value="claimant.email" disabled>
            <label for="telephone">Telephone</label>
            <input class="reviewInputs" type="text" id="telephone" ref="telephone" name="telephone" placeholder="" :value="claimant.telephone" disabled>
            <label for="altTelephone">Alternate telephone</label>
            <input class="reviewInputs" type="text" id="altTelephone" ref="altTelephone" name="altTelephone" placeholder="" :value="claimant.alternateTelephone" disabled>
        </form-container>
        <form-container class="mt-3">
            <div>
                <button class="button-small float-right" @click="() => { $router.push({ path: '6' }) }">Change</button>
                <h3>Your status</h3>
            </div>
            <p class="mt-3">You answered <strong>{{ ukResident ? 'YES' : 'NO'}}</strong> to "Are you a UK Resident"</p>
            <p>You answered <strong>{{ vatRegistered ? 'YES' : 'NO'}}</strong> to "Are you VAT registered"</p>
        </form-container>

        <form-container class="mt-3">
            <div>
                <button class="button-small float-right" @click="() => { $router.push({ path: '8' }) }">Change</button>
                <h3>The incident details</h3>
            </div>
            <p>You answered <strong>{{ otherClaims ? 'YES' : 'NO'}}</strong> to "Have you made a claim for any gadget within the last 2 years"</p>
            <div v-if="otherClaims === true">
              <label for="otherClaimsGadgetDetails">The details of the gadget(s) claimed for</label>
              <input class="reviewInputs" type="text" id="otherClaimsGadgetDetails" ref="otherClaimsGadgetDetails" name="otherClaimsGadgetDetails" placeholder="" :value="otherClaimsGadgetDetails" disabled>
              <label for="otherClaimsCompanyName">The name of the company who the claim was with</label>
              <input class="reviewInputs" type="text" id="otherClaimsCompanyName" ref="otherClaimsCompanyName" name="otherClaimsCompanyName" placeholder="" :value="otherClaimsCompanyName" disabled>
              <label for="otherClaimsOutcome">Details of the outcome of the claim</label>
              <input class="reviewInputs" type="text" id="otherClaimsOutcome" ref="otherClaimsOutcome" name="otherClaimsOutcome" placeholder="" :value="otherClaimsOutcome" disabled>
            </div>
            <label for="incidentType">Incident type</label>
            <input class="reviewInputs" type="text" id="incidentType" ref="incidentType" name="incidentType" placeholder="" :value="incidentDisplayText" disabled>
            <p>You answered <strong>{{ occurredAbroad ? 'YES' : 'NO'}}</strong> to "Did the incident occur abroad"</p>
            <div v-if="occurredAbroad"> <!-- Occurred abroad -->
                <label for="tripCountry">Country you visited</label>
                <input class="reviewInputs" type="text" id="tripCountry" ref="tripCountry" name="tripCountry" placeholder="" :value="incident.tripCountry" disabled>
                <label for="tripDates">Start and end dates of the trip</label>
                <input class="reviewInputs" type="text" id="tripDates" ref="tripDates" name="tripDates" placeholder="" :value="incident.tripStartDate + ' - ' + incident.tripEndDate" disabled>
            </div>

            <label for="dateOfIncident">Date occurred</label>
            <input class="reviewInputs" type="text" id="dateOfIncident" ref="dateOfIncident" name="dateOfIncident" placeholder="" :value="incident.dateOfIncident" disabled>
            <label for="timeOfIncident">Time occurred</label>
            <input class="reviewInputs" type="text" id="timeOfIncident" ref="timeOfIncident" name="timeOfIncident" placeholder="" :value="incident.timeOfIncident" disabled>
            <label for="descriptionOfIncident">What happened</label>
            <textarea id="descriptionOfIncident" ref="descriptionOfIncident" name="descriptionOfIncident" placeholder="" :value="incident.descriptionOfIncident" disabled></textarea>
            <label for="locationOfIncident">Where it happened</label>
            <textarea id="locationOfIncident" ref="locationOfIncident" name="locationOfIncident" placeholder="" :value="incident.locationOfIncident" disabled></textarea>
        </form-container>

        <form-container class="mt-3">
            <div v-for="(device, index) in devices"
                :key="index + 'gadget'">
                <div>
                    <button class="button-small float-right" @click="() => { $router.push({ path: '10' }) }">Change</button>
                    <h3>Gadget {{index + 1}}: {{device.deviceMakeLabel + ' / ' + device.deviceModelLabel}}</h3>
                </div>
                <label for="deviceDescription">Colour / memory / specification of the gadget</label>
                <textarea id="deviceDescription" ref="deviceDescription" name="deviceDescription" placeholder="" :value="device.deviceDescription" disabled></textarea>
                <div v-if="device.deviceSerial != ''">
                    <label for="deviceSerial">Gadget serial</label>
                    <input class="reviewInputs" type="text" id="deviceSerial" ref="deviceSerial" name="deviceSerial" placeholder="" :value="device.deviceSerial" disabled>
                </div>
                <div v-if="device.deviceIMEI != ''">
                    <label for="deviceIMEI">Gadget IMEI</label>
                    <input class="reviewInputs" type="text" id="deviceIMEI" ref="deviceIMEI" name="deviceIMEI" placeholder="" :value="device.deviceIMEI" disabled>
                </div>
                <div v-if="device.networkProviderId">
                    <label for="networkProviderId">Network provider</label>
                    <input class="reviewInputs" type="text" id="networkProviderId" ref="networkProviderId" name="networkProviderId" placeholder="" :value="device.networkProviderLabel" disabled>
                </div>
                <div v-if="device.contractTypeId">
                    <label for="contractTypeId">Contract type</label>
                    <input class="reviewInputs" type="text" id="contractTypeId" ref="contractTypeId" name="contractTypeId" placeholder="" :value="device.contractTypeLabel" disabled>
                </div>
                <p>You answered <strong>{{ device.purchasedByPolicyHolder ? 'YES' : 'NO'}}</strong> to "Did you purchase the gadget"</p>
                <label for="purchaseTypeId">Device was purchased...</label>
                <input class="reviewInputs" type="text" id="purchaseTypeId" ref="purchaseTypeId" name="purchaseTypeId" placeholder="" :value="device.purchaseTypeLabel" disabled>

                <div v-if="device.purchasedByPolicyHolder == false">
                  <label for="purchasedBy">Device purchased by</label>
                  <input type="text" id="purchasedBy" ref="purchasedBy" name="purchasedBy" placeholder="" :value="device.purchasedBy" disabled>  
                  <label for="relationshipTypeLabel">Their relationship to you</label>
                  <input type="text" id="relationshipTypeLabel" ref="relationshipTypeLabel" name="relationshipTypeLabel" placeholder="" :value="device.relationshipTypeLabel" disabled>  
                </div>

                <div v-if="isIncidentADMB">
                  <div
                      class="mb-3"
                      v-if="device.selectedDamageTypes && device.selectedDamageTypes.length > 0">
                      <p>You selected the following damage to the gadget</p>

                          <span
                              class="badge badge-pill badge-danger"
                              v-for="(damageType, index) in device.selectedDamageTypes"
                              :key="index">
                              {{damageType.label}}
                          </span>

                  </div>
                  <label for="damageDescription">Description of the damage</label>
                  <textarea id="damageDescription" ref="damageDescription" name="damageDescription" placeholder="" :value="device.damageDescription" disabled></textarea>
                  <p>You answered <strong>{{ device.deviceSwitchOn ? 'YES' : 'NO'}}</strong> to "Does the gadget switch on"</p>
                  <p>You answered <strong>{{ device.deviceLayFlat ? 'YES' : 'NO'}}</strong> to "Does the gadget lay flat when placed on a flat surface"</p>
                </div>
                <div v-if="isIncidentTL">
                  <label for="deviceLocation">Location of the gadget</label>
                  <textarea id="deviceLocation" ref="deviceLocation" name="deviceLocation" placeholder="" :value="device.deviceLocation" disabled></textarea>
                  <p>You answered <strong>{{ device.blacklistRequested == true ? 'YES' : 'NO'}}</strong> to "Have you requested that the device be blacklisted"</p>
                  <div v-if="device.blacklistRequested == true">
                    <label for="dateOfBlacklist">Date of the blacklist request</label>
                    <input class="reviewInputs" type="text" id="dateOfBlacklist" ref="dateOfBlacklist" name="dateOfBlacklist" placeholder="" :value="device.dateOfBlacklist" disabled>
                  </div>
                  <p>You answered <strong>{{ device.reportedToPolice == true ? 'YES' : 'NO'}}</strong> to "Was the incident reported to the police"</p>
                  <div v-if="device.reportedToPolice == true">
                    <label for="reportedToPoliceDate">Date the incident was reported</label>
                    <input class="reviewInputs" type="text" id="reportedToPoliceDate" ref="reportedToPoliceDate" name="reportedToPoliceDate" placeholder="" :value="device.reportedToPoliceDate" disabled>
                    <label for="policeStationAddress">Address of the police station where reported</label>
                    <input class="reviewInputs" type="text" id="policeStationAddress" ref="policeStationAddress" name="policeStationAddress" placeholder="" :value="device.policeStationAddress" disabled>
                    <label for="policeCrimeReference">Crime number / other reference</label>
                    <input class="reviewInputs" type="text" id="policeCrimeReference" ref="policeCrimeReference" name="policeCrimeReference" placeholder="" :value="device.policeCrimeReference" disabled>
                  </div>
                </div>
                <p>You answered <strong>{{ device.devicePolicyholderPossession ? 'YES' : 'NO'}}</strong> to "Was the gadget in the possesion of the policyholder"</p>
                <div v-if="device.devicePolicyholderPossession == false">
                  <h4>Details of the person who was in possession of the device...</h4>
                  <label for="relationshipLabel">Relationship to you</label>
                  <input class="reviewInputs" type="text" id="relationshipLabel" ref="relationshipLabel" name="relationshipLabel" placeholder="" :value="device.possessionDetails.relationshipLabel" disabled>
                  <label for="title">Title</label>
                  <input class="reviewInputs" type="text" id="title" ref="title" name="title" placeholder="" :value="device.possessionDetails.title" disabled>
                  <label for="firstname">First name</label>
                  <input class="reviewInputs" type="text" id="firstname" ref="firstname" name="firstname" placeholder="" :value="device.possessionDetails.firstname" disabled>
                  <label for="lastname">Last name</label>
                  <input class="reviewInputs" type="text" id="lastname" ref="lastname" name="lastname" placeholder="" :value="device.possessionDetails.lastname" disabled>
                  <label for="email">Email</label>
                  <input class="reviewInputs" type="text" id="email" ref="email" name="email" placeholder="" :value="device.possessionDetails.email" disabled>
                  <label for="telephone">Telephone</label>
                  <input class="reviewInputs" type="text" id="telephone" ref="telephone" name="telephone" placeholder="" :value="device.possessionDetails.telephone" disabled>
                  <label for="line1">Address</label>
                  <input class="reviewInputs" type="text" id="line1" ref="line1" name="line1" placeholder="" :value="device.possessionDetails.address.line1" disabled>
                  <input class="reviewInputs" type="text" id="line2" ref="line2" name="line2" placeholder="" :value="device.possessionDetails.address.line2" disabled>
                  <label for="city">Town / City</label>
                  <input class="reviewInputs" type="text" id="city" ref="city" name="city" placeholder="" :value="device.possessionDetails.address.city" disabled>
                  <label for="county">County</label>
                  <input class="reviewInputs" type="text" id="county" ref="county" name="county" placeholder="" :value="device.possessionDetails.address.county" disabled>
                  <label for="postcode">Postcode</label>
                  <input class="reviewInputs" type="text" id="postcode" ref="postcode" name="postcode" placeholder="" :value="device.possessionDetails.address.postcode" disabled>
                </div>
            </div>
        </form-container>

        <form-container v-if="documents && documents.length > 0" class="mt-3">
            <div>
              <button class="button-small float-right" @click="() => { $router.push({ path: '11' }) }">Upload more</button>
            </div>
            <h3 class="mb-3">You uploaded these documents...</h3>            
            <div
                v-for=" (document, index) in documents"
                :key="'document_' + index"
                class="row mb-2">
                <div class="col-sm-4">
                    <label><strong>
                        {{documentIdToTitle(document.typeId)}}
                    </strong></label>
                </div>
                <div class="col">
                    {{document.originalFilename}}<br />
                    <pdf-viewer 
                              :url="baseUrl + '/api/v1/document/download/' + document.internalFilename" 
                              v-if="isPdfFile(document.originalFilename)" />
                    <img
                        :src="baseUrl + '/api/v1/document/download/' + document.internalFilename"
                        class="img-thumbnail" v-else>
                </div>
            </div>
        </form-container>

        <form-container class="mt-3">
            <h3 class="mb-3">And finally...</h3>

            <h4>You indicated that you had read and understood the following statements</h4>
            <form-declaration :display="0"></form-declaration>
            <hr />
            <form-declaration :display="1"></form-declaration>
            <hr />
            <form-declaration :display="2"></form-declaration>
            <hr />

            <form-alert class="mt-3" :show="(claimFormSaveMsg && claimFormSaveMsg.length > 0)" :flavour="1" :resellerId="resellerIdAsNumber">{{claimFormSaveMsg}}</form-alert>
            <form-button-bar
                :back_button_enable='true'
                :back_button_show='true'
                :back_button_icon_enable='true'
                :back_button_action='() => $router.go(-1)'
                :save_button_enable='true'
                :save_button_show='true'
                :save_button_icon_enable='true'
                :save_button_action='handleSaveClick'
                :next_button_enable='true'
                :next_button_show='true'
                :next_button_label="'Submit'"
                :next_button_icon_enable='true'
                :next_button_action='handleReviewSubmit' />
        </form-container>

        <loading :active.sync="isLoading"
            :can-cancel="false"
            :is-full-page="true"></loading>

    </div>

</template>

<script>
import tigaClaimForm from '@/mixins/tigaClaimForm'
import FormContainer from '@/components/FormContainer.vue'
import FormDeclaration from '@/components/FormDeclaration.vue'
import FormAlert from '@/components/FormAlert.vue'
import FormButtonBar from '@/components/standaloneForm/FormButtonBar.vue'

import loading from 'vue-loading-overlay'
import { mapGetters } from 'vuex';

import PdfViewer from '@/components/pdf-viewer/PdfViewer.vue'
export default {
  name: 'review',
  mixins: [
    tigaClaimForm
  ],
  components: {
    loading,
    FormContainer,
    FormDeclaration,
    FormAlert,
    FormButtonBar,
    PdfViewer
  },
  data () {
    return {
      // resellerInfo: require('../../assets/theme/' + process.env.VUE_APP_RESELLER_ID + '/reseller.json'),
      checked: false,
      cardClass: 'card border-left-blue border-left-5 mb-2'
    }
  },

  mounted () {
    //console.log("Mounted")
    if (!this.claimformHasPolicyNumber || 
      !this.claimformHasClaimant || 
      !this.claimformHasIncidentType || 
      !this.claimformHasClaimantUKRes ||
      !this.claimformHasClaimantVATReg ||
      !this.claimformHasIncidentDetails ||
      !this.claimformHasGadgets ||
      !this.claimformHasDeclarations) {
      this.gotoStage1();
    }
  },
  computed: {
    ...mapGetters({
      resellerInfo: 'reseller/getResellerInfo'
    }),
    claimantAddress () {
      return this.claimant.address
    },
    incident () {
      return this.claimForm.data.incident
    },
    devices () {
      return this.claimForm.data.gadgets
    },
    documents () {
      return this.claimForm.data.documents
    },
    incidentDisplayText () {
      return this.selectedIncidentTypeL1.label + ' - ' + this.selectedIncidentTypeL2.label
    },
    occurredAbroad () {
      return this.claimForm.data.occurredAbroad
    },
    otherClaims () {
      return this.claimForm.data.otherClaims
    },
    otherClaimsGadgetDetails () {
      return this.claimForm.data.otherClaimsGadgetDetails
    },
    otherClaimsCompanyName () {
      return this.claimForm.data.otherClaimsCompanyName
    },
    otherClaimsOutcome () {
      return this.claimForm.data.otherClaimsOutcome
    },
    ukResident () {
      return this.claimant.ukResident
    },
    vatRegistered () {
      return this.claimant.vatRegistered
    },
    isIncidentTL () {
      let { selectedIncidentTypeL1 } = this
      if (selectedIncidentTypeL1) {
        return selectedIncidentTypeL1.id == 1001 || selectedIncidentTypeL1.id == 1002
      }
      return false
    },
    isIncidentADMB () {
       let { selectedIncidentTypeL1 } = this
      if (selectedIncidentTypeL1) {
        return selectedIncidentTypeL1.id == 1000 || selectedIncidentTypeL1.id == 1003
      }
      return false
    },
    stageTitle() {
      return this.$textManager.getText("title", this.$route.name)
    }
  },
  methods: {
    damageTypesForGadget (gadget) {
      if (gadget) {
        return Array.prototype.map.call(gadget.selectedDamageTypes, t => t.label).toString()
      }
    },
    handleReviewSubmit () {
      this.submitClaimForm()
    },
    handleNextClick () {
      // this.setAgreeDeclaration( { agreeDeclaration: this.checked } )
      // this.$router.push({ path: '17' })
    },
    handleSaveClick () {
      this.saveClaimForm()
    },
    documentIdToTitle: (id) => ({
      1000: "Proof of Purchase/Ownership",
      1003: "Photographs of Damage",
      1005: "Proof of Usage",
      1007: "Additional Supporting Documentation"
    }[id]),
    isPdfFile(filename) {
      let nameArr = filename.split('.');
      let fileExt = nameArr[nameArr.length -1];
      if(fileExt === 'pdf') {
        return true;
      } else {
        return false;
      }
    }
  }
}
</script>

<style scoped>
</style>
